import { render, staticRenderFns } from "./MobileApprovalProcess.vue?vue&type=template&id=3448c976&scoped=true&"
import script from "./MobileApprovalProcess.vue?vue&type=script&lang=js&"
export * from "./MobileApprovalProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448c976",
  null
  
)

export default component.exports